import image1 from "../assets/t-image1.JPG";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "My coat always comes out super shiny and I get a treat afterwards.",
    name: 'LUKAS',
    status : 'Good boi'
  },
  {
    image: image2,
    review: 'I will catch the water as it comes out of the spout one day!',
    name: 'SYDNEY',
    status: 'Bestest girl'
  },
  {
    image : image3,
    review:'My mom likes it when I smell gud.',
    name: 'FRANKLIN',
    status: "Big softie"
  }
];
